export default __webpack_public_path__ + "static/media/profile.fc5d12a4.svg";